import React from 'react'
import PropTypes from 'prop-types'
import './FavoriteIcon.scss'

const FavoriteIcon = props => {
  const handleClick = e => {
    e.stopPropagation()
    props.handleClick()
  }

  const classes = `fa fa-2x ${props.highlighted ? 'highlighted fa-star' : 'fa-star'}`
  return (
    <span className="favorite-icon">
      <i className={classes} aria-hidden="true" onClick={handleClick} title={props.altText} />
    </span>
  )
}

FavoriteIcon.propTypes = {
  handleClick: PropTypes.func.isRequired,
  highlighted: PropTypes.bool,
  altText: PropTypes.string.isRequired
}

export default FavoriteIcon
